import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
export const axiosPublic = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    //headers: { 'Content-Type': 'application/json', 'Access':'1000' },
    withCredentials: true,
});

// Response interceptor
axiosPrivate.interceptors.response.use(
    response => response,
    async (error) => {
        const originalRequest = error.config;
        
        // Check if it's a 401 error and we haven't already tried to refresh
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                // Import useRefreshToken dynamically to avoid circular dependency
                const { default: useRefreshToken } = await import('../../Hooks/useRefreshToken');
                
                // Create a temporary instance to call the refresh function
                const refreshToken = useRefreshToken();
                await refreshToken();
                
                // For cookie-based auth, we don't need to set Authorization header
                // The server will read the new access_token from cookies
                // Just retry the original request
                return axiosPrivate(originalRequest);
            } catch (refreshError) {
                // Refresh failed, redirect to login
                // Token refresh failed - redirecting to login
                
                // Clear any stored auth data
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
                
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosPrivate;